import Collectible from './Collectible'

export default Collectible
